import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-[var(--bg)] text-[var(--text-1)] flex items-center"
    >
      <Seo
        title="404 · Not found · KS DevArc"
        description="The page you're looking for has drifted out of the grid."
      />
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none" />
      <div className="relative mx-auto max-w-3xl w-full px-5 sm:px-8 py-24 text-center">
        <div className="overline mb-6">// signal_lost</div>
        <h1 className="font-display font-black text-7xl md:text-[12rem] tracking-tight leading-[0.9]">
          4<span className="text-[var(--vermilion)]">0</span>4
        </h1>
        <p className="mt-6 text-[var(--text-2)] max-w-md mx-auto leading-relaxed">
          The page drifted out of the grid. Either the URL changed, or the route
          never existed in this dimension.
        </p>
        <div className="mt-10 flex items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="not-found-home"
            className="inline-flex items-center gap-2 px-5 py-3 bg-[var(--vermilion)] hover:bg-[var(--vermilion-2)] text-white text-sm rounded-full transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <Link
            to="/blog"
            data-testid="not-found-blog"
            className="inline-flex items-center gap-2 px-5 py-3 border border-[var(--border-dim)] hover:border-[var(--lime)] hover:text-[var(--lime)] text-sm rounded-full transition-colors"
          >
            Read the blog
          </Link>
        </div>
      </div>
    </div>
  );
}
